import * as React from 'react'

class ErrorMsg extends React.Component {
    render() {
        const {text, children, additionalClass} = this.props;
        return (
            <span className={`ec-error__msg ${additionalClass || ''} mb-3`}>
                {text || children}
            </span>
        )
    }
}

export default ErrorMsg